<!-- V3 -->
<ng-container  *ngIf="this.getStepperVersion() === stepperType.V3" [id]="getId()" class="kt-grid  kt-wizard-v2 kt-wizard-v2--white" id="kt_wizard_v2"
  data-ktwizard-state="step-first">
  <div class="kt-grid__item kt-wizard-v2__aside">
    <div class="kt-wizard-v2__nav">
      <div class="kt-wizard-v2__nav-items">
        <a *ngFor="let stepperItem of stepperItems" [id]="getRealStepperId(stepperItem.controlProperties.id)"
          class="kt-wizard-v2__nav-item" data-ktwizard-type="step"
          (click)="changeStep(getRealStepperId(stepperItem.controlProperties.id))">
          <div class="kt-wizard-v2__nav-body">
            <div class="kt-wizard-v2__nav-icon">
              <i class="{{stepperItem.controlProperties.iconClass}}"></i>
            </div>
            <div class="kt-wizard-v2__nav-label">
              <div class="kt-wizard-v2__nav-label-title"
                [id]="getRealStepperId(stepperItem.controlProperties.id + '_title')">
                {{stepperItem.controlProperties.title}}
              </div>
              <div *ngIf="stepperItem.controlProperties.readOnly" class="kt-wizard-v2__nav-label-desc"
                [id]="getRealStepperId(stepperItem.controlProperties.id + '_description')">
                {{stepperItem.controlProperties.disabledDescription}}
              </div>
              <div *ngIf="!stepperItem.controlProperties.adnShowValue && !stepperItem.controlProperties.readOnly"
                class="kt-wizard-v2__nav-label-desc"
                [id]="getRealStepperId(stepperItem.controlProperties.id + '_description')">
                {{stepperItem.controlProperties.description}}
              </div>
              <div *ngIf="stepperItem.controlProperties.adnShowValue && !stepperItem.controlProperties.readOnly"
                class="kt-wizard-v2__nav-label-desc"
                [id]="getRealStepperId(stepperItem.controlProperties.id + '_show')">
                {{stepperItem.controlProperties.adnShowValue}}
              </div>
            </div>
            <div class="kt-wizard-v2__nav-icon nav-checked">
              <i class="fa fa-check-circle"></i>
            </div>
          </div>
        </a>

      </div>
    </div>
    <!--end: Form Wizard Nav -->
  </div>
  <div class="kt-grid__item kt-grid__item--fluid kt-wizard-v2__wrapper">
    <form class="kt-form" id="kt_form">
      <ng-container #stepperItemsTarget></ng-container>
    </form>
  </div>
</ng-container >

<!--V4-->
<ng-container  *ngIf="this.getStepperVersion() === stepperType.V4">
  <ul class="nav nav-tabs nav-tabs-line nav-tabs-bold nav-tabs-line-3x nav-tabs-line-success">
    <li [class.done-step]="step.getState() == 'done'" *ngFor="let step of getStepperItems();let i = index" [id]="step.getId()" [class.active]="step.getActive()" class="nav-item"
      [class.disabled]="step.getReadOnly()">
      <a class="nav-link step-link" (click)="goToStep(i)">
        <i [ngClass]="getIconClass(step)"></i>
        <span class="d-none d-md-inline-block ms-3 text-upper">{{step.getTitle()}}</span>
      </a>
    </li>
  </ul>

  <div class="tab-content p-4">
    <ng-container #target></ng-container>
  </div>

  <div class="button-container px-4 py-2">
    <button class="btn btn-secondary-stepper m-4" *ngIf="getCurrentIndex() != 0 && getCurrentIndex() != (stepperItems.length-1)" (click)="prevStep()">Regresar</button>
    <button class="btn btn-primary-stepper m-4 float-end" style="margin-right: 33px !important;"  *ngIf="getCurrentIndex() != (stepperItems.length-1)" (click)="nextStep()">Siguiente</button>
    <button class="btn btn-primary-stepper m-4 float-end" *ngIf="getCurrentIndex() == (stepperItems.length-1)" (click)="finishStep()">Finalizar</button>
  </div>
</ng-container >

<!-- Compressed version -->
<div *ngIf="this.getStepperVersion() === stepperType.Compressed">
  <div class="d-flex justify-content-center compressed-stepper-container">
    <div class="stepper-container"
    [style.width]="this.getWidth()+'px'"
    [style.min-height]="this.getHeight()+'px'"> 
         <!-- progress bar  -->
         <div *ngIf="this.getHasProgressBar()">
           <ng-container #progressBarContainer></ng-container>
         </div>
         <!-- stepperItem content -->
        <div class="tab-content p-4 compressed-tab-content">
          <ng-container #target></ng-container>
        </div>
    </div>
  </div>
</div>

<!-- full version -->
<div *ngIf="this.getStepperVersion() === stepperType.Full"
     class="stepper-full-container" [ngClass]="{
      'stepper-full-with-header-md': this.getFullStepperHasHeader() && !this.isExtraSmall,
      'stepper-full-with-header-xsm': this.getFullStepperHasHeader() && this.isExtraSmall
     }">

     <!-- full stepper bar -->
     <div class="full-stepper-bar th-bg-main" 
          [ngClass]="{
            'position-fixed': this.getIsStepperFullFixed()
          }"
          *ngIf="this.getFullStepperHasHeader()">
            <!-- stepper item options -->
        <div class="d-flex justify-content-center align-items-center description-options-container" 
            *ngIf="this.getStepperItemsStepperFull().length > 0 && !this.isExtraSmall">

            <div *ngFor="let stepperItem of this.getStepperItemsStepperFull(); let i=index"
                    class="d-flex align-items-center">
                <!-- stepper item icon -->
                <div class="stepper-full-completed-container circle d-flex justify-content-center align-items-center"
                    [ngClass]="{
                        'th-bg-stepper-item-not-completed' : !this.isStepperFullItemActive(i) && !this.isStepperFullItemCompleted(i),
                        'th-bg-secondary' : this.isStepperFullItemActive(i),
                        'th-bg-confirmation': this.isStepperFullItemCompleted(i) && !this.isStepperFullItemActive(i)
                    }">
                    <div *ngIf="this.isStepperFullItemCompleted(i)">
                      <img src="assets/icons/normal-check.svg" width="12" height="10">
                    </div>
                </div>
                <!-- stepper item title -->
                <span class="bs-h3 th-text-white"
                      [ngClass]="{
                        'title-default-weight' : !this.isStepperFullItemActive(i)
                      }">{{stepperItem.getTitle()}}
                </span>

                <!-- spacing between items -->
                <div *ngIf="i < (this.getStepperItemsStepperFull().length - 1)"
                     class="stepper-full-spacing-bar th-bg-stepper-item-not-completed">
                </div>

            </div>
        </div>

        <!-- stepper item options for extra small devices -->
        <div *ngIf="this.getStepperItemsStepperFull().length > 0 && this.isExtraSmall">
            <div class="d-flex justify-content-center align-items-center main-extra-small-options-container">

                <!-- options -->
                <div class="extra-small-option d-flex justify-content-center align-items-center flex-column" 
                     *ngFor="let stepperItem of this.getStepperItemsStepperFull(); let i=index"
                     [ngClass]="{
                        'first-extra-small-option': i===0,
                        'last-extra-small-option': i===(this.getStepperItemsStepperFull().length - 1)
                     }">
                    <div class="circle-container">
                        <div class="circle extra-small-circle d-flex justify-content-center align-items-center" 
                        [ngClass]="{
                            'th-bg-stepper-item-not-completed' : !this.isStepperFullItemActive(i) && !this.isStepperFullItemCompleted(i),
                            'th-bg-secondary' : this.isStepperFullItemActive(i),
                            'th-bg-confirmation': this.isStepperFullItemCompleted(i) && !this.isStepperFullItemActive(i)
                        }">
                        <div *ngIf="this.isStepperFullItemCompleted(i)">
                            <img src="assets/icons/normal-check.svg" width="12" height="10">
                          </div>
                        </div>
                        <div class="extra-small-circle-line"></div>
                    </div>
                    <!-- stepper item title -->
                    <span class="bs-h3 th-text-white"
                          *ngIf="stepperItem.stepperItemType !== stepperItemTypesEnum.confirmation"
                        [ngClass]="{
                        'title-default-weight' : !this.isStepperFullItemActive(i)
                        }">{{stepperItem.getTitle()}}
                    </span>
                </div>
            </div>
        </div>
    </div>
    <div class="stepper-item-container-full">
      <ng-container #target></ng-container>
    </div>
</div>